import React, { useRef, useEffect, useState } from "react";
import NumberInput from "common/NumberInput";
import { getFormData, rankAndParseFields } from "./utils";
import { parseInterfaceList, parseWireNames } from "./api";
import SelectInput from "common/SelectInput";
import Request from "common/Request";
import { atBqnGiven } from "common/api";

// The BQN being edited is the one given, and no BQN in particular is asked
// for its interfaces when there is none to edit yet.
const getDevicesList = (wires, bqnId) =>
  ifCl
    .run(atBqnGiven("show interface raw", bqnId))
    .then((response) => parseInterfaceList(response, wires));

const getWireNames = () =>
  ifCl.run("show config running | match wire").then(parseWireNames);

const getDevices = (bqnId) => getWireNames().then((wires) => getDevicesList(wires, bqnId));

const asLabelAndValue = ({ name }) => ({
  label: name,
  value: name,
});

const InterfaceSelection = ({
  onChange,
  name,
  label,
  defaultValue = undefined,
  bqnId,
}) => {
  const [request, setRequest] = useState(null);
  useEffect(() => {
    setRequest(getDevices(bqnId).then((list) => ({ list })));
  }, []);

  return request === null ? null : (
    <Request during={request}>
      {({ list }) => (
        <SelectInput
          name={name}
          label={label}
          defaultValue={defaultValue}
          onChange={onChange}
          options={list.map(asLabelAndValue)}
          className="input-control align-left"
        />
      )}
    </Request>
  );
};
const SynSettings = ({
  onChange,
  defaults = {},
  isOperatorProfile = false,
  bqnId,
}) => {
  const form = useRef(null);
  const onInputChange = (event) => {
    const values = getFormData(form.current);
    const {value, name } = event.target;
    if (name==='interface'){
      onChange({...defaults, ...values, [name]:value});
    } else {
      onChange({...defaults, ...values});
    }
  };
  return (
    <form ref={form}>
      <h2 className="card-inside-title">Network Interface</h2>
      <p>Management network interface</p>
      <InterfaceSelection
        name="interface"
        label="Interface"
        defaultValue={defaults.interface}
        onChange={onInputChange}
        disabled={isOperatorProfile}
        bqnId={bqnId}
      />
      <h2 className="card-inside-title">VLAN</h2>
      <p>Management network Interface VLAN ID</p>
      <NumberInput
        name="vlan"
        label="VLAN ID"
        defaultValue={defaults.vlan}
        onChange={onInputChange}
        className="input-control align-left"
        placeHolder="1-4096, empty for none"
        precision={0}
        disabled={isOperatorProfile}
        type="text"
      />
    </form>
  );
};

export default SynSettings;
